const emblem = {
  elements: [
    { id: 1, slug: 'text' , name: '文字' },
    { id: 2, slug: 'goods' , name: '野球' },
    { id: 3, slug: 'mosa' , name: '猛者' },
    { id: 4, slug: 'player' , name: 'プレイヤー' },
    { id: 5, slug: 'animal' , name: '動物' },
  ],
  items: [
    // 文字
    {
      id: 1,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_01.svg'
    },
    {
      id: 2,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_02.svg'
    },
    {
      id: 3,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_03.svg'
    },
    {
      id: 4,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_04.svg'
    },
    {
      id: 5,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_05.svg'
    },
    {
      id: 6,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_06.svg'
    },
    {
      id: 7,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_07.svg'
    },
    {
      id: 8,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_08.svg'
    },
    {
      id: 9,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_09.svg'
    },
    {
      id: 10,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_10.svg'
    },
    {
      id: 11,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_11.svg'
    },
    {
      id: 12,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_12.svg'
    },
    {
      id: 13,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_13.svg'
    },
    {
      id: 14,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_14.svg'
    },
    {
      id: 15,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_15.svg'
    },
    {
      id: 16,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_16.svg'
    },
    {
      id: 17,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_17.svg'
    },
    {
      id: 18,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_18.svg'
    },
    {
      id: 19,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_19.svg'
    },
    {
      id: 20,
      element_id: 1,
      image_url: '/simulator/images/emblem/emblem_text_20.svg'
    },
    // 野球
    {
      id: 21,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_01.svg'
    },
    {
      id: 22,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_02.svg'
    },
    {
      id: 23,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_03.svg'
    },
    {
      id: 24,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_04.svg'
    },
    {
      id: 25,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_05.svg'
    },
    {
      id: 26,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_06.svg'
    },
    {
      id: 27,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_07.svg'
    },
    {
      id: 28,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_08.svg'
    },
    {
      id: 29,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_09.svg'
    },
    {
      id: 30,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_10.svg'
    },
    {
      id: 31,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_11.svg'
    },
    {
      id: 32,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_12.svg'
    },
    {
      id: 33,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_13.svg'
    },
    {
      id: 34,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_14.svg'
    },
    {
      id: 35,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_15.svg'
    },
    {
      id: 36,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_16.svg'
    },
    {
      id: 37,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_17.svg'
    },
    {
      id: 38,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_18.svg'
    },
    {
      id: 39,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_19.svg'
    },
    {
      id: 40,
      element_id: 2,
      image_url: '/simulator/images/emblem/emblem_goods_20.svg'
    },
    // 猛者
    {
      id: 41,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_01.svg'
    },
    {
      id: 42,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_02.svg'
    },
    {
      id: 43,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_03.svg'
    },
    {
      id: 44,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_04.svg'
    },
    {
      id: 45,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_05.svg'
    },
    {
      id: 46,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_06.svg'
    },
    {
      id: 47,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_07.svg'
    },
    {
      id: 48,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_08.svg'
    },
    {
      id: 49,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_09.svg'
    },
    {
      id: 50,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_10.svg'
    },
    {
      id: 51,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_11.svg'
    },
    {
      id: 52,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_12.svg'
    },
    {
      id: 53,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_13.svg'
    },
    {
      id: 54,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_14.svg'
    },
    {
      id: 55,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_15.svg'
    },
    {
      id: 56,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_16.svg'
    },
    {
      id: 57,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_17.svg'
    },
    {
      id: 58,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_18.svg'
    },
    {
      id: 59,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_19.svg'
    },
    {
      id: 60,
      element_id: 3,
      image_url: '/simulator/images/emblem/emblem_mosa_20.svg'
    },
    // プレイヤー
    {
      id: 61,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_01.svg'
    },
    {
      id: 62,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_02.svg'
    },
    {
      id: 63,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_03.svg'
    },
    {
      id: 64,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_04.svg'
    },
    {
      id: 65,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_05.svg'
    },
    {
      id: 66,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_06.svg'
    },
    {
      id: 67,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_07.svg'
    },
    {
      id: 68,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_08.svg'
    },
    {
      id: 69,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_09.svg'
    },
    {
      id: 70,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_10.svg'
    },
    {
      id: 71,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_11.svg'
    },
    {
      id: 72,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_12.svg'
    },
    {
      id: 73,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_13.svg'
    },
    {
      id: 74,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_14.svg'
    },
    {
      id: 75,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_15.svg'
    },
    {
      id: 76,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_16.svg'
    },
    {
      id: 77,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_17.svg'
    },
    {
      id: 78,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_18.svg'
    },
    {
      id: 79,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_19.svg'
    },
    {
      id: 80,
      element_id: 4,
      image_url: '/simulator/images/emblem/emblem_player_20.svg'
    },
    // 動物
    {
      id: 81,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_01.svg'
    },
    {
      id: 82,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_02.svg'
    },
    {
      id: 83,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_03.svg'
    },
    {
      id: 84,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_04.svg'
    },
    {
      id: 85,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_05.svg'
    },
    {
      id: 86,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_06.svg'
    },
    {
      id: 87,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_07.svg'
    },
    {
      id: 88,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_08.svg'
    },
    {
      id: 89,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_09.svg'
    },
    {
      id: 90,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_10.svg'
    },
    {
      id: 91,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_11.svg'
    },
    {
      id: 92,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_12.svg'
    },
    {
      id: 93,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_13.svg'
    },
    {
      id: 94,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_14.svg'
    },
    {
      id: 95,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_15.svg'
    },
    {
      id: 96,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_16.svg'
    },
    {
      id: 97,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_17.svg'
    },
    {
      id: 98,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_18.svg'
    },
    {
      id: 99,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_19.svg'
    },
    {
      id: 100,
      element_id: 5,
      image_url: '/simulator/images/emblem/emblem_animal_20.svg'
    },
  ],
}
export default emblem
